import { render } from "./FieldInstanceValue.vue?vue&type=template&id=234c117d"
import script from "./FieldInstanceValue.vue?vue&type=script&lang=js"
export * from "./FieldInstanceValue.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__